import React from 'react';
import T from 'prop-types';

import { Container, Title, Body } from './style';

const PageHeader = ({ title, children }) => (
  <Container>
    <Title>{title}</Title>
    {children && <Body>{children}</Body>}
  </Container>
);

PageHeader.defaultProps = {
  children: null,
};

PageHeader.propTypes = {
  title: T.string.isRequired,

  children: T.node,
};

export default PageHeader;
